import React from "react";
import { observer } from "mobx-react";
import { THEME_SETTINGS } from "@theme-settings";
import {
	HeaderLogo,
	HeaderMenuToggleButton,
	HeaderSpecialLinks,
	HeaderTop,
} from "../components";
import HeaderFailedLoginsCheckButton from "../components/HeaderFailedLoginsCheckButton";
import HeaderUserBalance from "../components/HeaderUserBalance";
import HeaderAuthenticationButtons from "../components/HeaderAuthenticationButtons";
import { useRootAppStore } from "@hooks";

export default observer(function MainPageHeader() {
	const {
		userAuthStore: { isLoggedIn },
	} = useRootAppStore();

	return (
		<header className="l--header l__header">
			<div className="header header--root">
				<div className="header__top">
					<HeaderTop />

					<HeaderSpecialLinks />
				</div>

				<div className="header__main header--root__main">
					<HeaderLogo />

					<nav className="header__nav">
						{isLoggedIn ? (
							<>
								{THEME_SETTINGS.failedLoginReport.isEnabled && (
									<HeaderFailedLoginsCheckButton />
								)}
								<HeaderUserBalance />
							</>
						) : (
							<HeaderAuthenticationButtons />
						)}

						<HeaderMenuToggleButton />
					</nav>
				</div>
			</div>

			<div id="account24HourLockPopup" />
		</header>
	);
});
